import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import type {UnmanagedCourseT} from '@freckle/school/ts/common/models/unmanaged-course'
import type {UnmanagedSummaryT} from '@freckle/school/ts/rostering/components/clean-up-roster/clean-up-phase'
import {CourseSummary} from '@freckle/school/ts/rostering/components/clean-up-roster/course-summary'
import ConfirmButton from '@freckle/school/ts/rostering/components/common/confirm-button'
import {FinishedMerging} from '@freckle/school/ts/rostering/components/common/finished-merging'
import {Success} from '@freckle/school/ts/rostering/components/common/success'
import Warning from '@freckle/school/ts/rostering/components/common/warning'

type Props = {
  unmanaged: UnmanagedSummaryT
  archivedCourses: Array<UnmanagedCourseT>
  onReview: () => void
  onArchive: () => void
}

export function ArchiveCourses({unmanaged, archivedCourses, onReview, onArchive}: Props) {
  const {t} = useSafeTranslation()
  return (
    <>
      <FinishedMerging unmanaged={unmanaged} />
      <br />
      <Success muted title={t('ARCHIVE_COURSES_SUCCESS_TITLE')}>
        <CourseSummary courses={archivedCourses} onReview={onReview} />
        <Warning text={t('ARCHIVE_COURSES_WARN_STUDENT_LOGIN')} />
        <Warning text={t('ARCHIVE_COURSES_WARN_IDP')} />
        <Warning text={t('ARCHIVE_COURSES_WARN_PERSONAL_EMAIL')} />
        <Warning text={t('ARCHIVE_COURSES_WARN_UNAFFILIATE')} />
        <ConfirmButton
          dataTest="confirm-delete-courses"
          text={t('ARCHIVE_COURSES_CONFIRM_BUTTON_DELETE')}
          onConfirm={onArchive}
        />
      </Success>
    </>
  )
}
